type Props = {
  label: string
  value: string
  sub?: string
  tone?: "default" | "alert"
}

export function StatTile({ label, value, sub, tone = "default" }: Props) {
  return (
    <div className="border border-border bg-card px-3 py-2.5">
      <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground">
        {label}
      </div>
      <div
        className="mt-1 font-mono text-2xl leading-none tabular-nums"
        style={tone === "alert" ? { color: "var(--viz-failed)" } : undefined}
      >
        {value}
      </div>
      {sub ? (
        <div className="mt-1 text-xs text-muted-foreground">{sub}</div>
      ) : null}
    </div>
  )
}
